<template>
  <v-container class="pessoas">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de Pessoa"
          home="/administracao"
        />
        <Cadastro />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Cadastro from '../cadastros/pessoas'
export default {
  name: 'Pessoas',
  components: { PageTitle, Cadastro },
  data: () => ({

  })
}
</script>
